module.exports = __webpack_public_path__ + "static/media/walls-and-water.b3ea027a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/gamePlumbing/walls-and-water.png
// module id = 2293
// module chunks = 0